import { type ValueOf } from "type-fest";
import { BadPaymentResponseError } from "utils/error/bad-payment-response";

const CHECKOUT_ERRORS: Record<
  "default" | (string & {}), // eslint-disable-line @typescript-eslint/ban-types
  "cardDetails" | "transactionIssues"
> = {
  "20005": "transactionIssues",
  "20051": "transactionIssues",
  "20059": "transactionIssues",
  "20063": "cardDetails",
  "200N7": "cardDetails",
  "20182": "transactionIssues",
  default: "cardDetails",
};

export function errorFormatter(
  error: unknown,
  {
    creditCardErrors,
    provider,
  }: {
    creditCardErrors: Record<ValueOf<typeof CHECKOUT_ERRORS>, string>;
    provider: string | null;
  },
) {
  const result: { description?: string; footer?: string } = {};

  if (error instanceof BadPaymentResponseError) {
    if (provider === "checkOut" && error.details?.code) {
      const errorKey =
        CHECKOUT_ERRORS[error.details.code] ?? CHECKOUT_ERRORS.default;
      result.description = creditCardErrors[errorKey];
    } else {
      result.description =
        error.details?.description ??
        (error.details?.code
          ? `Error code: ${error.details.code}`
          : error.message);
    }

    if (error.details?.footer) {
      result.footer = error.details.footer;
    }
  } else {
    result.description =
      typeof error === "string"
        ? error
        : String((error as { message?: unknown })?.message ?? error);
  }

  return result;
}
